var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 20,
    viewBox: "0 0 27 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4278 13.0243C14.7701 13.4628 14.0061 13.6946 13.2184 13.6946C12.4308 13.6946 11.6668 13.4628 11.0091 13.0243L0.176021 5.8021C0.115919 5.76203 0.0573657 5.72026 0 5.6773V17.5117C0 18.8686 1.1011 19.9454 2.43368 19.9454H24.003C25.3599 19.9454 26.4367 18.8443 26.4367 17.5117V5.67725C26.3793 5.72031 26.3206 5.76219 26.2603 5.80231L15.4278 13.0243Z",
    fill: "#DA716A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03527 4.51336L11.8683 11.7357C12.2784 12.0091 12.7484 12.1457 13.2183 12.1457C13.6884 12.1457 14.1584 12.009 14.5685 11.7357L25.4015 4.51336C26.0498 4.08144 26.4368 3.35856 26.4368 2.57836C26.4368 1.23685 25.3454 0.145508 24.0039 0.145508H2.43286C1.0914 0.145559 0 1.2369 0 2.57965C0 3.35856 0.387051 4.08144 1.03527 4.51336Z",
    fill: "#DA716A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailIco);
export default __webpack_public_path__ + "static/media/mail-ico.7071fdca1aa5cd63f5772183fcc110ed.svg";
export { ForwardRef as ReactComponent };